// src/utils/slugUtils.js

/**
 * Convert a string to a URL-friendly slug
 */
export const createSlug = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/[\s_-]+/g, '-') // Replace spaces and underscores with hyphens
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
};

/**
 * Generate slug from article title or use existing slug
 */
export const getArticleSlug = (article) => {
  if (article.slug) return article.slug;
  if (article.title) return createSlug(article.title);
  if (article.filename) {
    // Remove date prefix and .md extension
    const withoutExt = article.filename.replace(/\.md$/, '');
    const withoutDate = withoutExt.replace(/^\d{4}-\d{2}-\d{2}-/, '');
    return createSlug(withoutDate);
  }
  return '';
};

/**
 * Generate slug from project title or use existing slug
 */
export const getProjectSlug = (project) => {
  if (project.slug) return project.slug;
  if (project.title) return createSlug(project.title);
  if (project.filename) {
    // Remove date prefix and .md extension
    const withoutExt = project.filename.replace(/\.md$/, '');
    const withoutDate = withoutExt.replace(/^\d{4}-\d{2}-\d{2}-/, '');
    return createSlug(withoutDate);
  }
  return '';
};

/**
 * Generate company slug from company name
 */
export const getCompanySlug = (companyName) => {
  if (!companyName) return '';
  return createSlug(companyName);
};

